const state = {
  ezopenToken: ''
}

const mutations = {
  ezopenTokenUpdate(state, playload) {
    state.ezopenToken = playload
    localStorage.setItem('ezopenToken', playload)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
